import i, { css as a } from "styled-components";
import { Text as t } from "./atoms-v243.js";
import { Link as n } from "./atoms-v224.js";
import { breakpoints as d } from "./atoms-v2125.js";
import { Button as s } from "./atoms-v26.js";
const b = i.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: auto;
  justify-content: center;
  padding-block: 20px;
  width: 100%;

  @media ${d.medium} {
    padding-block: 40px;
  }

  @media ${d.large} {
    gap: 20px;
    padding-block: 0;
  }

  @media ${d.xLarge} {
    gap: 32px;
  }
`, u = i.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0 8px 16px;
  width: 100%;

  @media ${d.large} {
    border-bottom: 1px solid ${({ theme: o }) => o == null ? void 0 : o.get("tokens.border.light.light")};
  }
`, k = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.02").toJS()};

  @media ${d.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.03").toJS()};
  }

  @media ${d.xLarge} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.04").toJS()};
  }
`, y = i.div`
  align-items: center;
  display: none;
  gap: 12px;

  @media ${d.large} {
    display: flex;
  }
`, c = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};

  @media ${d.large} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};
  }

  @media ${d.xLarge} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.heading.03").toJS()};
  }
`, e = i(c)`
  text-decoration: line-through;
`, v = i.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-start;
  width: 100%;
`, f = i.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  width: 100%;
`, S = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};

  @media ${d.large} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};
  }
`, R = i(n)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.secondary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};
`, J = i(n)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};
`, w = i.div`
  --border-color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.border.${o}.light`)};
  --border-color-selected: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.border.${o}.main`)};

  border-left: 1px solid
    ${({ $isSelected: o }) => o ? "var(--border-color-selected)" : "var(--border-color)"};
  border-right: 1px solid
    ${({ $isSelected: o }) => o ? "var(--border-color-selected)" : "var(--border-color)"};
  border-top-left-radius: ${({ $isFirst: o, theme: r }) => o ? r == null ? void 0 : r.get("tokens.radius.cardRadiusMed") : 0}px;
  border-top-right-radius: ${({ $isFirst: o, theme: r }) => o ? r == null ? void 0 : r.get("tokens.radius.cardRadiusMed") : 0}px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px 16px;
  width: 100%;

  @media ${d.medium} {
    padding: 20px 26px;
  }

  ${({ $isFirst: o, $isSelected: r }) => o && a`
      border-top: 1px solid ${r ? "var(--border-color-selected)" : "var(--border-color)"};
    `}

  ${({ $isPreviousSelected: o }) => !o && a`
      border-top: 1px solid var(--border-color);
    `}

  ${({ $isSelected: o }) => o && a`
      border-bottom: 1px solid var(--border-color-selected);
      border-top: 1px solid var(--border-color-selected);
      z-index: 1;
    `}
`, C = i.div`
  display: flex;
  flex-direction: column;

  @media ${d.medium} {
    flex-direction: row;
    justify-content: space-between;
  }
`, M = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};

  @media ${d.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};
  }
`, T = i.div`
  display: flex;
  gap: 4px;
`, B = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.secondary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.productive").toJS()};

  @media ${d.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};
  }
`, L = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};

  @media ${d.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.productive").toJS()};
  }
`, j = i.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`, z = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.tertiary`)};

  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};
`, P = i.div`
  align-items: center;
  border: 1px solid ${({ theme: o }) => o == null ? void 0 : o.get("tokens.border.light.light")};
  border-bottom-left-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.cardRadiusMed")}px;
  border-bottom-right-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.cardRadiusMed")}px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 14px 16px;
  width: 100%;

  @media ${d.medium} {
    padding: 16px 26px;
  }

  ${({ $isPreviousSelected: o }) => o && a`
      border-top: none;
    `}
`, D = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.secondary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};

  @media ${d.medium} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.productive").toJS()};
  }
`, F = i.div`
  align-items: center;
  display: none;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  @media ${d.large} {
    display: flex;
  }
`, H = i.div`
  display: flex;
  gap: 8px;
  width: 100%;

  > button {
    flex: 1;
    flex-shrink: 1;
    min-width: 0;
  }
`, A = i(t)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.tertiary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.xs-productive").toJS()};
  text-align: center;

  a {
    color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.tertiary`)};
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.xs-productive").toJS()};
  }
`, V = i(s)`
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};
`;
export {
  P as AdditionalRatesButton,
  D as AdditionalRatesButtonText,
  F as ButtonFooter,
  A as ButtonFooterText,
  H as ButtonGroup,
  V as FooterButton,
  w as RateCard,
  b as RateCardContainer,
  z as RateCardDescription,
  C as RateCardHeader,
  B as RateCardPrice,
  T as RateCardPriceSection,
  L as RateCardPriceText,
  M as RateCardTitle,
  j as RateCardsWrapper,
  u as RateMainHeader,
  c as RateMainPrice,
  e as RateMainStrikeThroughPrice,
  y as RateMainSubtitle,
  k as RateMainTitle,
  f as RateSectionHeader,
  S as RateSectionTitle,
  v as RatesSection,
  R as ViewDetailsLink,
  J as ViewRateDetailsLink
};
